/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter, Link } from "react-router-dom";
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class FindPwdResult extends Component {
  _login = () => {
    const { history } = this.props;
    history.push("/login");
  };
  _goBack = () => {
    const { history } = this.props;
    const { onFindPwdCode } = this.props.childProps;
    onFindPwdCode(100, "", 1);
    history.goBack();
  };
  render() {
    const { findPwdCode, findId } = this.props.childProps;
    return (
      <Fragment>
        <div className="login_content width4">
          {findPwdCode === 0 ? (
            <div className="login_padding">
              <h1>임시 비밀번호 발송</h1>
              <div className="login_end">
                임시비밀 번호가 <span>{findId}</span>로 발송 되었습니다.
                <br />
              </div>
              <div className="login_btn">
                <a style={{ cursor: "pointer" }} onClick={this._login}>
                  로그인
                </a>
              </div>
            </div>
          ) : findPwdCode === 4 ? (
            <div className="login_padding">
              <h1>탈퇴한 회원 계정</h1>
              <div className="login_end">
                회원님이 찾으신 아이디는 이미 탈퇴한 계정입니다.
                <br />
              </div>
              <div className="login_btn">
                <a style={{ cursor: "pointer" }} onClick={this._goBack}>
                  확인
                </a>
              </div>
            </div>
          ) : findPwdCode === -1 ? (
            <div className="login_padding">
              <h1>일치 회원 계정</h1>
              <div className="login_end">
                일치하는 사용자 계정을 찾을 수 없습니다.
                <br />
                <br />
                아이디를 찾을 수 없는 경우,
                <br />
                <Link to="/customer/0">고객센터</Link>로 연락해 주세요.
              </div>
              <div className="login_btn">
                <a style={{ cursor: "pointer" }} onClick={this._goBack}>
                  확인
                </a>
              </div>
            </div>
          ) : (
            <div className="login_padding">
              <h1>오류</h1>
              <div className="login_end">
                잘못된 경로 또는 알수 없는 오류입니다.
                <br />
                <br />
                계속 같은 현상이 발생하면,
                <br />
                <Link to="/customer/0">고객센터</Link>로 연락해 주세요.
              </div>
              <div className="login_btn">
                <a style={{ cursor: "pointer" }} onClick={this._goBack}>
                  확인
                </a>
              </div>
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(FindPwdResult));
